module.exports = __webpack_public_path__ + "img/login_b.2f29f11f.png";